

















































import { Component, Vue } from "vue-property-decorator";
import JS001Vue from "../components/Gsnb/JS001.vue";
import JS007Vue from "../components/Gsnb/JS007.vue";
import JS009Vue from "../components/Gsnb/JS009.vue";
import TzsbVue from "../components/Gsnb/Tzsb.vue";
import GdczVue from "../components/Gsnb/Gdcz.vue";
import JS010Vue from "../components/Gsnb/JS010.vue";
import WzwdVue from "../components/Gsnb/Wzwd.vue";
import DwdbVue from "../components/Gsnb/Dwdb.vue";
import GqbgVue from "../components/Gsnb/Gqbg.vue";
import DwtzVue from "../components/Gsnb/Dwtz.vue";
import TbxzVue from "../components/Gsnb/Tbxz.vue";
import TjxxVue from "../components/Gsnb/Tjxx.vue";
import XkzVue from "../components/Gsnb/Xkz.vue";
import KjqyVue from "../components/Gsnb/Kjqy.vue";
import version from "@/version";

@Component({
    components: {
        JS001: JS001Vue,
        JS007: JS007Vue,
        JS009: JS009Vue,
        JS010: JS010Vue,
        tzsb: TzsbVue,
        gdcz: GdczVue,
        dwdb: DwdbVue,
        wzwd: WzwdVue,
        gqbg: GqbgVue,
        dwtz: DwtzVue,
        tjxx: TjxxVue,
        xkz: XkzVue,
        kjqy: KjqyVue,
        tbxz: TbxzVue
    }
})
export default class Gsnb extends Vue {
    tabList:any = {
        tbxz: { name: "填报须知", sp: "填报\n须知" },
        jbxx: { name: "企业基本信息", sp: "基本\n信息" },
        tzsb: { name: "特种设备信息", sp: "特种\n设备" },
        gdcz: { name: "股东及出资信息", sp: "股东\n出资" },
        wzwd: { name: "网站或网店信息", sp: "网站\n网店" },
        gqbg: { name: "股权变更信息", sp: "股权\n变更" },
        dwtz: { name: "对外投资信息", sp: "对外\n投资" },
        zczk: { name: "资产状况信息", sp: "资产\n状况" },
        dwdb: { name: "对外担保信息", sp: "对外\n担保" },
        djxx: { name: "党建信息", sp: "党建\n信息" },
        sbxx: { name: "社保信息", sp: "社保\n信息" },
    };
    currentTab = this.tabList.jbxx;

    form = {
        isSure: <number | null>null,
        isWeb: <number | null>null,
        isHolding: <number | null>null,
        isBuy: <number | null>null,
        isScience: <number | null>null, 
        year: <string | null>(new Date().getFullYear() - 1).toString()
    }

    // 下载
    down() {
        let url = `${Vue.axios.defaults.baseURL}export/pdf/gsnb?accountBookId=${this.$store.state.accountBook.id}&year=${this.form.year}&version=${version}&token=${this.$store.state.account.token}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
    async getCount() {
        const res = await Vue.axios.post(`gsnb/record/count`, {
            year: this.form.year,
            ids: this.$store.state.accountBook.id
        });
        if (res.data.message) this.$message({
            type: res.data.success ? "success" : "warning",
            message: res.data.message
        });
        if (res.data.success) this.refresh();
    }

    isShow(tab: string) {
        if(this.$store.state.accountBook.accountBookInfo.province ===  "辽宁省") {
            if(this.tabList.kjqy) {
                if (tab === this.tabList.kjqy.name) return this.form.isScience;
            }
        }
        if (tab === this.tabList.dwdb.name) return this.form.isSure;
        else if (tab === this.tabList.wzwd.name) return this.form.isWeb;
        else if (tab === this.tabList.gqbg.name) return this.form.isHolding;
        else if (tab === this.tabList.dwtz.name) return this.form.isBuy;
        return true;
    }

    updateBasic(form: { isSure: number | null; isWeb: number | null; isHolding: number | null; isBuy: number | null;isScience: number | null; }) {
        this.form = JSON.parse(JSON.stringify(form));
    }

    refresh() {
        const content: any = this.$refs.content;
        if (content && content.fetchData) content.fetchData();
    }
    mounted() {
        if(this.$store.state.accountBook.accountBookInfo.province ===  "辽宁省") {
            this.tabList = {
                tbxz: { name: "填报须知", sp: "填报\n须知" },
                jbxx: { name: "企业基本信息", sp: "基本\n信息" },
                tzsb: { name: "特种设备信息", sp: "特种\n设备" },
                gdcz: { name: "股东及出资信息", sp: "股东\n出资" },
                wzwd: { name: "网站或网店信息", sp: "网站\n网店" },
                gqbg: { name: "股权变更信息", sp: "股权\n变更" },
                dwtz: { name: "对外投资信息", sp: "对外\n投资" },
                zczk: { name: "资产状况信息", sp: "资产\n状况" },
                dwdb: { name: "对外担保信息", sp: "对外\n担保" },
                djxx: { name: "党建信息", sp: "党建\n信息" },
                sbxx: { name: "社保信息", sp: "社保\n信息" },
                kjqy: { name: "科技企业信息", sp: "科技\n企业" },
            };
        }
        if(this.$store.state.accountBook.accountBookInfo.province ===  "湖南省") {
            this.tabList = {
                tbxz: { name: "填报须知", sp: "填报\n须知" },
                jbxx: { name: "企业基本信息", sp: "基本\n信息" },
                tzsb: { name: "特种设备信息", sp: "特种\n设备" },
                gdcz: { name: "股东及出资信息", sp: "股东\n出资" },
                wzwd: { name: "网站或网店信息", sp: "网站\n网店" },
                gqbg: { name: "股权变更信息", sp: "股权\n变更" },
                dwtz: { name: "对外投资信息", sp: "对外\n投资" },
                zczk: { name: "资产状况信息", sp: "资产\n状况" },
                dwdb: { name: "对外担保信息", sp: "对外\n担保" },
                djxx: { name: "党建信息", sp: "党建\n信息" },
                tjxx: { name: "团建信息", sp: "团建\n信息" },
                sbxx: { name: "社保信息", sp: "社保\n信息" },
            };
        }
        if(this.$store.state.accountBook.accountBookInfo.province ===  "湖北省") {
            this.tabList={
                tbxz: { name: "填报须知", sp: "填报\n须知" },
                jbxx: { name: "企业基本信息", sp: "基本\n信息" },
                tzsb: { name: "特种设备信息", sp: "特种\n设备" },
                gdcz: { name: "股东及出资信息", sp: "股东\n出资" },
                wzwd: { name: "网站或网店信息", sp: "网站\n网店" },
                gqbg: { name: "股权变更信息", sp: "股权\n变更" },
                dwtz: { name: "对外投资信息", sp: "对外\n投资" },
                zczk: { name: "资产状况信息", sp: "资产\n状况" },
                dwdb: { name: "对外担保信息", sp: "对外\n担保" },
                djxx: { name: "党建信息", sp: "党建\n信息" },
                sbxx: { name: "社保信息", sp: "社保\n信息" },
                xkz: { name: "充装单位许可证", sp: "充装\n单位" },
            }
        }
    }
}
